import { HTTP_METHODS } from '@studio/constants/axios';
import { PLAYER_CONFIG_API_V1 } from '@studio/constants/env-variables';
import type { PlayerProfiles } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${PLAYER_CONFIG_API_V1}/customers/@customerId/fts`,
    response: {} as PlayerProfiles.Get.FirstTimeSetupStatus,
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
